import styled from "styled-components";
import { select } from "@hubper/theme";
import { ROW_HEIGHT } from "../constants";

export const HeaderCellBase = styled.div`
  transition: border 0.3s;
  box-sizing: border-box;
  overflow: hidden;
  font-size: ${select.fontSize(-2)};
  color: ${select.color(["grey", 6])};
  height: ${ROW_HEIGHT}px;
  font-family: ${select.font("Lato")};
  text-transform: uppercase;
  user-select: none;
`;

export const Inner = styled.div`
  padding: 6px 0px 6px 6px;
  display: flex;
  height: 100%;
  box-sizing: border-box;
  align-items: center;
`;

export const Label = styled.div`
  transition: background-color 0.2s;
  flex: 1 1 auto;
  height: 100%;
  border-radius: 3px;
  padding: 6px;
  box-sizing: border-box;
  display: flex;
  align-items: center;

  cursor: pointer;

  &:hover {
    background-color: ${select.color(["grey", 0])};
    color: ${select.color(["grey", 9])};
  }
`;

export const Right = styled.div<{ active: boolean }>`
  margin-left: 4px;
  display: flex;
  align-items: center;
  height: 100%;
  cursor: pointer;
  padding: 0 4px;
  width: 18px;

  &:hover svg {
    fill: ${p => select.color(["grey", p.active ? 9 : 7], p)};
  }

  & > svg {
    width: ${p => (p.active ? 9 : 11)}px;
    height: ${p => (p.active ? 9 : 11)}px;

    fill: ${p =>
      p.active ? select.color(["grey", 9], p) : select.color(["grey", 4])};
  }
`;

export const CloseWrapper = styled.div`
  flex: 0 0 16px;
  padding-left: 8px;

  cursor: pointer;
  color: ${select.color(["grey", 4])};

  &:hover {
    color: ${select.color(["grey", 8])};
  }
`;
